export const API_URL: string = process.env.REACT_APP_API_URL!;
export const ASSET_URL: string = process.env.REACT_APP_ASSET_BASE_URL!;
export const FCM_VAPID_KEY: string = process.env.REACT_APP_FCM_VAPID_KEY!;
export const GOOGLE_MAPS_API_KEY: string = process.env.REACT_APP_GOOGLE_MAPS_API_KEY!;
